"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProvidersWrapper = exports.CareTeamsProvidersHeader = exports.CareTeamsProvidersContainer = exports.AltProvidersHeader = exports.AltProvidersContainer = exports.SidebarContent = exports.SidebarContainer = void 0;
// import { fromTheme } from '@kyruus/ui-theme';
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const breakpoints_1 = require("../../lib/constants/breakpoints");
exports.SidebarContainer = (0, styled_1.default)('div') `
  display: block; // needed for position: sticky in SidebarContent
`;
exports.SidebarContent = (0, styled_1.default)('div') `
  position: sticky;
  top: ${(props) => props.headerHeight + 'px'};
  max-width: ${breakpoints_1.SIDEBAR_WIDTH};
`;
exports.AltProvidersContainer = (0, styled_1.default)('div') `
  & > div > div {
    flex-basis: 100%;
  }
  overflow: hidden;
`;
exports.AltProvidersHeader = (0, styled_1.default)('h2') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
`;
exports.CareTeamsProvidersContainer = (0, styled_1.default)('div') `
  & > div > div {
    flex-basis: 100%;
  }
  overflow: hidden;
`;
exports.CareTeamsProvidersHeader = (0, styled_1.default)('h2') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
`;
exports.StyledProvidersWrapper = (0, styled_1.default)('div') `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
//# sourceMappingURL=styles.js.map